import {useEffect, useState} from 'react';
import {Image} from '@shopify/hydrogen';
import clsx from 'clsx';

type Props = {
  label: React.ReactNode;
  defaultChecked?: boolean;
  center?: boolean;
  onCheckHandler?: (checked: boolean) => void;
  labelProps?: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export function CheckboxField({
  label,
  defaultChecked = false,
  center = false,
  onCheckHandler,
  labelProps,
  ...props
}: Props) {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  useEffect(() => {
    setIsChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <div className="my-2">
      <label
        {...labelProps}
        className={clsx(
          'flex cursor-pointer items-center space-x-[10px]',
          labelProps?.className,
        )}
      >
        {isChecked ? (
          <Image
            src="/checkbox-checked.svg"
            alt="checkbox-checked"
            width={20}
            height={20}
            className="h-[20px] w-[20px]"
          />
        ) : (
          <Image
            src="/checkbox-default.svg"
            alt="checkbox-default"
            width={20}
            height={20}
            className="h-[20px] w-[20px]"
          />
        )}
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => {
            const checked = isChecked;
            // setIsChecked((prev) => !prev);
            setIsChecked(!checked);
            onCheckHandler && onCheckHandler(!checked);
          }}
          className="hidden"
          {...props}
        />
        <span>{label}</span>
      </label>
    </div>
  );
}
